module.exports = {"id":"209301","name":"Maxime Poundjé","rating":"72","photo":"./data/images/photos/4/209301.png","club":{"name":"Girondins de BX","logo":"./data/images/clubs/GirondinsdeBX.png"},"positions":["DG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MaximePoundje0.json
// module id = 2943
// module chunks = 0